// @flow
import env from '../../../environment';
import {
  getCreator,
  postCreator,
  putCreator,
  deleteCreator,
} from '../../../http';
import type {CouponType} from '../../../entities';

export type CouponRequest = {
  code?: string,
  discount?: string,
  couponType?: CouponType,
  activationDate?: string,
  expirationDate?: string,
  featured?: boolean,
  minimumRequirements?: {
    orderItemsAmount?: string,
    orderItemsQuantity?: number,
  },
};

export const endpoints = Object.freeze({
  GET_COUPONS: `${env.baseApiUrl}/im/admin/coupon`,
  GET_COUPON: `${env.baseApiUrl}/im/admin/coupon/:couponId`,
  CREATE_COUPON: `${env.baseApiUrl}/im/admin/coupon`,
  EDIT_COUPON: `${env.baseApiUrl}/im/admin/coupon/:couponId`,
  DELETE_COUPON: `${env.baseApiUrl}/im/admin/coupon/:couponId`,
});

export const getCouponsApi = getCreator(endpoints.GET_COUPONS);
export const getCouponApi = getCreator(endpoints.GET_COUPON);
export const createCouponApi = postCreator(endpoints.CREATE_COUPON);
export const editCouponApi = putCreator(endpoints.EDIT_COUPON);
export const deleteCouponApi = deleteCreator(endpoints.DELETE_COUPON);
